<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar title="重置密码" align="center">
      <!--返回上一层-->
      <mu-icon value="keyboard_arrow_left" color="white" slot="left" v-on:click="goback" />
      <mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />
    </mu-appbar>

    <br />

    <div class="gxx1">
      <div align=left>

        <mu-text-field hintText="请输入手机号" type="text" icon="smartphone" v-model="UserPhone" fullWidth="" style="margin-left:-4% ; width:103% " />
        <nobr>
          <mu-text-field hintText="请输入手机验证码" type="text" icon="verified_user" v-model="YZM" style="margin-left:-4% ; width:69% ; z-index: 1" class="txtValidate" />

          <span v-show="haveYZM == false">
            <input type="button" id="j-popup" value="获取" style="font-size:0.32rem ; float:right ; background-color:#27ba69 ; height: 0.7rem  ; border:none  ;  width: 30% ;  color:white" />
          </span>
          <span v-show="haveYZM == true">
            <input type="button" v-model="WaitTime" style="font-size:0.32rem ; float:right ;   background-color:#eeeeee ;   height: 0.7rem  ; border:none  ;  width: 30% ; color:#999 ;" />
          </span>
        </nobr>
      </div>

      <!--outline:0 ;-->

      <mu-raised-button label="重置密码" primary="" @click="getPass" v-bind:style="{ width:'100%',height:'50px' }" style="font-size:0.3rem ; margin-top:0.5rem" />
      <br />
      <br />
      <br /> 系统将自动通过短信将密码发送到您的手机上
    </div>

    <mu-toast v-if="toast" v-bind:message="this.TellUser" @close="hideToast" id="alertline" />
    <div id="captcha"></div>
  </div>
</template>




<style lang="less" scoped="">
@import '../../../assets/theme.less';

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  .gxx1 {
    width: 82%;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .Green {
    background-color: @primaryColor;
  }

  .Black {
    color: @primaryBlack;
  }

  .Grey {
    color: @textColor;
  }
}
</style>





<script>
import { mapMutations, mapGetters } from 'vuex'
import api from '../../../api'

export default {
  data() {
    return {
      UserPhone: '',
      FJM: '',
      YZM: '',

      TPFJM: '',

      haveYZM: false,
      WaitTime: '',
      CloseTime: 29,

      toast: false,
      TellUser: '',
      //网易云盾验证码
      validate: '',
      //屏幕宽度
      WinWidth: document.body.clientWidth
    }
  },
  // 数据获取
  computed: {
    ...mapGetters(['g_UserInfo'])
  },
  //进入时运作
  activated() {
    this.UserPhone = ''
    this.FJM = ''
    this.YZM = ''
    this.InitNetEaseDun()
  },
  methods: {
    // 图片验证码
    getValidateCode() {
      // 用户已登录
      if (this.g_UserInfo.Card_no) {
        // console.log(this.g_UserInfo)
        this.$router.push({ path: '/user/UserCenter' })
      }
      this.TPFJM = api.getValidateCode()
    },

    //  获取验证码
    getYZM() {
      if (this.UserPhone == '') {
        this.TellUser = '请滑动或点击完成验证'
        this.showToast()
      }  else {
        // 开始计时
        this.haveYZM = true
        this.WaitTime = this.CloseTime + '秒'
        this.timer()

        var params = new this.URLSearchParam()
        params.append('phoneNo', this.UserPhone)
        params.append('captcha', this.validate)

        this.$http
          .post(api.ForgetPasswordForSMS(), params.toParam())
          .then(res => {
            window.captchaInsC.refresh() //清理验证码
            if (res.Result == true) {
              this.TellUser = res.Data
              this.showToast()
            } else {
              // 失败
              this.TellUser = res.Message
              this.showToast()
              this.getValidateCode()

              this.CloseTime = 5
            }
          })
      }
    },

    timer() {
      if (this.CloseTime > 0) {
        this.CloseTime--
        this.WaitTime = this.CloseTime + '秒'

        setTimeout(this.timer, 1000)
      } else if (this.CloseTime == 0) {
        this.haveYZM = false
        this.CloseTime = 29
        return
      }
    },
    //  获取验证码  END

    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => {
        this.toast = false
      }, 1500)
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end

    // 后退一页
    goback() {
      // javascript:history.go(-1);
      this.$router.push({ path: '/user/Login' })
    },
    //  获取密码
    getPass() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号'
        this.showToast()
      } else if (this.YZM == '') {
        this.TellUser = '请输入手机验证码'
        this.showToast()
      } else {
        var params = new this.URLSearchParam()
        params.append('phoneNo', this.UserPhone)
        params.append('validateCode', this.YZM)

        this.$http.post(api.ForgetPassword(), params.toParam()).then(res => {
          if (res.Result) {
            // this.TellUser = res.Data;
            // this.showToast();

            // 让登陆直接进usercenter

            setTimeout(() => {
              this.TellUser = '密码重置成功，即将跳转进入登录页'
              this.showToast()
              setTimeout(() => {
                this.$router.push({
                  path: '/user/Login?backURL=/user/UserCenter'
                })
              }, 1500)
            }, 1500)
          } else {
            this.TellUser = res.Message
            this.showToast()
          }
        })
      }
    },
    //网易云盾
    InitNetEaseDun() {
      if (window.captchaInsC != undefined) {
        return
      }
      //网易云盾初始化
      var that = this
      var captchaIns
      var winWidth = this.WinWidth <= 320 ? 'auto' : '280'
      initNECaptcha(
        {
          element: '#captcha',
          captchaId: '883464f032c9481a891b5fb9fb49bd23',
          mode: 'popup',
          width: winWidth,
          onVerify: function(err, data) {
            if (
              err != undefined ||
              data == undefined ||
              data.validate == undefined
            ) {
              that.validate = ''
              that.TellUser = '验证有误！请重新验证'
              that.toastTimer = 5
              that.showToast()
              return
            }
            that.validate = data.validate
            that.getYZM()
          }
        },
        function(instance) {
          // 初始化成功后得到验证实例instance，可以调用实例的方法
          captchaIns = instance
          window.captchaInsC = captchaIns
        },
        function(err) {
          // 初始化失败后触发该函数，err对象描述当前错误信息
        }
      )

      // 监听button的点击事件，弹出验证码
      document.getElementById('j-popup').addEventListener('click', function() {
        if (that.UserPhone == '') {
          that.TellUser = '请输入手机号'
          that.showToast()
        } else if (that.UserPhone.length != 11) {
          that.TellUser = '手机号格式不正确'
          that.showToast()
        } else {
          if (that.validate.length > 0) {
            captchaIns.refresh()
          }
          captchaIns.popUp()
        }
      })
    },
    ...mapMutations(['setG_UserInfo'])

    // watch 对于后退，没用啊
  }
}
</script>










// WEBPACK FOOTER //
// ForgotPass.vue?fe3a147c